import { Route, useRouteMatch } from 'react-router-dom';

import { CreateRiskRegisterModal } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/CreateRiskRegisterModal/CreateRiskRegisterModal';
import { UpdateRiskRegisterModal } from 'components/widgets/RiskRegister/components/RiskRegisterRoutes/components/UpdateRiskRegisterModal/UpdateRiskRegisterModal';

export const RiskRegisterRoutes = () => {
    const { path } = useRouteMatch();

    return (
        <>
            <Route path={`${path}/create`} render={() => <CreateRiskRegisterModal />} />
            <Route path={`${path}/update-:riskId`} render={() => <UpdateRiskRegisterModal />} />
        </>
    );
};
